import { useEffect } from "react";

import { useQueryClient } from "react-query";

const useQueryClearCache = (key: string | string[]) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    return () => {
      const keys = typeof key === "string" ? [key] : key;
      keys.forEach((k) => queryClient.removeQueries(k));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default useQueryClearCache;
